export default {
  namespaced: true,
  state() {
    return {
      snackbar:{
      isOn: false,
      message: '',
      cta: ''
      }
    }
  },
  getters: {
    snackbarData(state) {
      return state.snackbar
    },
  },
  mutations: {
    updateSnackbar(state, payload) {
      !payload.message && (payload.message = 'Function not ready yet.')
      !payload.cta && (payload.cta = 'Dismiss')
      state.snackbar = payload
    }
  },
  actions: {
    updateSnackbar({ commit }, payload) {
      commit('updateSnackbar', payload)
    }
  }
}
